import React from 'react';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../../tc-ui/two-column-row.jsx';
import {
  multiDayTourDescrs as fieldList,
} from '../../../../../utils/contracting-preset-names-codes';
import R from 'ramda';

const NonAccomRates = ({
  updateFieldValue,
  ...fieldValues }) => {
  const retailOrNett = fieldValues.rateType === 'includeCommission' ? 'retail' : 'nett';
  const nonAccomStandard = fieldValues.nonAccomStandard;
  const leftColumnStyle = { width: '30%', textAlign: 'left', fontSize: '15px' };
  const shouldDisableField = str => {
    if (str === 'Single') {
      return Boolean(R.path([retailOrNett, 'single supplement'], nonAccomStandard));
    }
    if (str === 'Single Supplement') {
      return Boolean(R.path([retailOrNett, 'single'], nonAccomStandard));
    }
    return false;
  };
  return (
    <TwoColumnRow
      leftColumnStyle={leftColumnStyle}
      rightColumnStyle={{ width: '70%', textAlign: 'left' }}
      outerContainerStyle={{ overflow: 'inherit', clear: 'both', marginTop: '12px' }}
      leftColumnContent={<div style={{ marginTop: '12px', position: 'relative', top: '12px' }}>
        Rates information
        <div style={{ color: 'red', fontSize: '12px', fontWeight: '400' }}>
          * At least one rate is required
        </div>
        {
          Boolean(R.path([retailOrNett, 'single'], nonAccomStandard)
          || R.path([retailOrNett, 'single supplement'], nonAccomStandard))
          && (
            <div style={{ fontSize: '12px', marginTop: '32px' }}>
              Please note, you cannot have both "Single" and "Single Supplement" rate.
            </div>
          )
        }
      </div>}
      rightColumnContent={
        <TwoColumnRow
          outerContainerStyle={{ overflow: 'inherit' }}
          leftColumnStyle={{ width: '45%' }}
          leftColumnContent={
            fieldValues.rateType === 'includeCommission' ? (
              <div>
                {
                  fieldList.map((field, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'baseline' }}>
                      <TypeControlledTextField
                        id={`${field}retail`}
                        disabled={shouldDisableField(field)}
                        controlledType="number"
                        errorStyle={{ fontSize: '10px', bottom: '10px' }}
                        style={{ width: '65%', marginRight: '18px', height: '48px' }}
                        hintStyle={{ fontSize: '12px', zIndex: '0' }}
                        floatingLabelStyle={{ fontSize: '12px', top: '18px' }}
                        inputStyle={{ fontSize: '14px', marginTop: '0' }}
                        floatingLabelText={field}
                        hintText="Number only"
                        value={nonAccomStandard.retail[field.toLowerCase()]}
                        onChange={({ target: { value } }) => updateFieldValue({
                          fieldName: field.toLowerCase(),
                          value,
                          nonAccomStandard: true,
                          retail: true,
                        })}
                      /><span style={{ position: 'relative', top: '6px', fontSize: '14px' }}>Retail</span>
                    </div>
                  ))
                }
              </div>
            ) : undefined
          }
          rightColumnStyle={{ float: fieldValues.rateType === 'includeCommission' ? 'right' : '', marginRight: '5%', width: '45%' }}
          rightColumnContent={
            <div>
              {
                fieldList.map((field, index) => {
                  return (
                    <div key={index} style={{ display: 'flex', alignItems: 'baseline' }}>
                      <TypeControlledTextField
                        controlledType="number"
                        id={`${field}nett`}
                        errorStyle={{ fontSize: '10px', bottom: '10px' }}
                        style={{ width: '65%', marginRight: '18px', height: '48px' }}
                        hintStyle={{ fontSize: '12px', zIndex: '0' }}
                        floatingLabelStyle={{ fontSize: '12px', top: '18px' }}
                        inputStyle={{ fontSize: '14px', marginTop: '0' }}
                        disabled={fieldValues.rateType === 'includeCommission' || shouldDisableField(field)}
                        floatingLabelText={field}
                        hintText="Number only"
                        value={nonAccomStandard.nett[field.toLowerCase()]}
                        onChange={({ target: { value } }) => updateFieldValue({
                          fieldName: field.toLowerCase(),
                          value,
                          nonAccomStandard: true,
                          nett: true,
                        })}
                      /><span style={{ position: 'relative', top: '6px', fontSize: '14px' }}>Nett</span>
                    </div>
                  );
                })
              }
            </div>
          }
        />
      }
    />
  );
};

export default NonAccomRates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-forms/non-accommo-rates-form-templates/multi-day-tour.jsx